<div *ngIf="hasAltActions" class="seperator"></div>
<ng-content select="mims-ribbon-button"></ng-content>
